import React, { Component } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import CustomButton from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import Grid from 'screens/components/basic/Grid';
import GenericTable from 'screens/components/advanced/GenericTable';
import CardSimple from 'screens/components/basic/CardSimple';
import DialogConfirm from 'screens/components/basic/DialogConfirm';
import DialogException from 'screens/components/basic/DialogException';
import * as XLSX from 'xlsx';
import { hideLoadingSpinner, showError, showLoadingSpinner, showSnackbar } from 'actions/CommonActions';
import { uploadexcel, getBulkPriceUpdateSchedular, deleteBulkPriceList, updateBulkPriceList } from 'actions/EntityActions';
import { bulkPriceCrumb } from 'utils/breadcrumbInfo';
import { clearFormInput, formInput, formError, clearFormErrors } from 'actions/FormActions';
import util from 'library/util';
import * as types from 'constants/actionTypes';
// Basic Components
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';
import Pagination from 'screens/components/basic/Pagination';
import ButtonFileUpload from 'screens/components/basic/ButtonFileUpload';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import SelectInput from 'screens/components/basic/SelectInput';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import TextInput from 'screens/components/basic/TextInput';

const pageName = "bulkUpdate";

class PriceUpdateList extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: false,
      selectedFile: null,
      activePage: 1,
      itemsPerPage: 25,
      branchId: 0,
      scheduleId: 0,
      isDialogOpen: false,
      isExceptionDialogOpen: false,
      isValidExcel: false,
    };
  }

  //-------------------
  //Get Scheduler List
  componentWillMount() {
    this.props.getBulkPriceUpdateSchedular(this.props.branchId, this.state.activePage, this.state.itemsPerPage);
  }

  componentWillReceiveProps(newProps) {
    if ((newProps.updatePriceSchedularUpdateTimeSuccess && newProps.updatePriceSchedularUpdateTimeSuccess !== this.props.updatePriceSchedularUpdateTimeSuccess)) {
      this.saveSuccess();
    }
    if ((newProps.validateExcelTimeSuccess && newProps.validateExcelTimeSuccess !== this.props.validateExcelTimeSuccess)) {
      this.validatedSuccess();
    }

    if (newProps.updateBulkPriceListSuccessTime && newProps.updateBulkPriceListSuccessTime !== this.props.updateBulkPriceListSuccessTime) {
      this.saveSuccess(newProps.updateBulkPriceListData);
    }
  }

  saveSuccess = (message) => {
    if (message) {
      this.props.showDialog(message);
    } else {
      this.props.showSnackbar(LOOKUP.priceUpdate.messages.createdMessage);
    }
    this.props.getBulkPriceUpdateSchedular(this.props.branchId, this.state.activePage, this.state.itemsPerPage);
    this.clearControl();
  }

  validatedSuccess = () => {
    this.setState({ isExceptionDialogOpen: true });
  }

  handleExceptionClose = () => {
    let that = this;
    that.setState({ isExceptionDialogOpen: false });
  }

  //Upload Excel File
  onFileChange = (event) => {
    event.preventDefault();

    const file = event.target.files[0];

    const hasOpenStatus = (this.props.bulkPriceSchedularList || []).some(item => item && item.status == 'OPEN');

    const validator = [
      ['selectedFileName', model => model.size < 10 * 1024 * 1024, "#File size exceeds 10 MB limit"],
      ['selectedFileName', model => model.name.endsWith('.xlsx') || model.name.endsWith('.xls'), "#File must be in Excel format (.xlsx)/(.xls)"],
      ['selectedFileName', model => !hasOpenStatus, "#Warning: This process cannot be completed, there is an Open Price Update in progress"],
    ];

    if (util.validate(validator, file, this.props.formError)) {
      this.setState({ selectedFile: file });
      this.props.formInput(file.name, "selectedFileName");
    }

    event.target.value = null;
  }

  //--------------------------------
  //Delete file events
  //---------------------------------
  redirectToDelete = (scheduleId) => {
    this.setState({ isDialogOpen: true, scheduleId: scheduleId });
  }

  handleDeleteConfirm = () => {
    // Handle confirm logic here
    if (this.state.scheduleId > 0) {
      this.props.deleteBulkPriceList(this.state.scheduleId);
      this.setState({ isDialogOpen: false, scheduleId: 0 });
      this.clearControl();
    } else {
      console.log("ScheduleId not found")
    }
  };

  handleDeleteCancel = () => {
    this.setState({ isDialogOpen: false, scheduleId: 0 });
  };

  handleChange = (value) => {
    if (value) {
      // console.log(dayjs(value), dayjs());
      const today = dayjs();
      let actualDate = dayjs(value);

      if (actualDate.diff(today, 'day') < 0) {
        this.props.formError("startDate", "Date should be greater than equal to today");
      } else {
        this.props.formError("startDate", "")
      }
    }
  }

  convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'pm') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}`;
  }

  //run update manually
  doBulkPriceUpdate = () => {
    let filterSchedule = this.props.bulkPriceSchedularList.filter((schedule) => {
      return schedule.status === 'OPEN';
    });
    if (filterSchedule.length > 0) {
      this.props.updateBulkPrice();
    } else {
      this.props.showError("No file found with 'OPEN' status to update price!!");
    }
  }

  // Save Template
  saveExcelData = () => {
    const p = this.props;
    let isTimeValid = true;

    // DateTime Validation
    const todayDate = new Date().toLocaleDateString('fr-CA');
    const startDate = new Date(p.startDate).toLocaleDateString('fr-CA');
    if (todayDate === startDate && p.startTime) {
      let currentTime = new Date().getHours();
      let selectedTime = this.convertTime12to24(p.startTime);
      if (currentTime >= selectedTime) {
        p.showError("Selected time should be greater than current date with time('" + startDate + " " + p.startTime.toUpperCase() + "')");
        isTimeValid = false;
      }
    }

    const validatorModel = {
      fileName: p.selectedFileName,
      startDate: p.startDate,
      startTime: p.startTime
    }

    const validators = [
      ['selectedFileName', model => model.fileName != '' && model.fileName != undefined && model.fileName != null, "File upload"],
      ['startDate', model => model.startDate != '' && model.startDate != undefined, "Start Date"],
      ['startTime', model => model.startTime != '' && model.startTime != undefined, "Start Time"]
    ];

    if (util.validate(validators, validatorModel, p.formError) && isTimeValid) {
      p.showLoading();
      const file = this.state.selectedFile;
      let reader = new FileReader();
      reader.onerror = () => p.hideLoading();
      reader.onload = (e) => {
        this.readExcelData(e, this, file.name);
      }
      reader.readAsBinaryString(file);
    } else {
      return false;
    }
  }

  getList = () => {
    const bid = this.props.branchId;
    const page = this.state.activePage;
    const ipage = this.state.itemsPerPage
    this.props.getBulkPriceUpdateSchedular(
      bid,
      page,
      ipage
    )
  }

  changePage = (e) => {

    this.setState(pState => {
      return {
        ...pState,
        activePage: e
      };
    }, this.getList);
  }

  clearControl = () => {
    this.setState({ selectedFile: null });
    this.props.clearFormInput("startDate");
    this.props.clearFormInput("startTime");
    this.props.clearFormInput("startTimeText");
    this.props.clearFormInput("selectedFileName");
    this.props.clearFormErrors();
  }

  handleTimeChange = (value) => {
    // console.log(this.props.startDate);
    if (value && !this.props.startDate) {
      this.props.formInput("", "startTime");
      this.props.formError("startTime", "Select start date first to set time");
    } else {
      if (!value) {
        this.props.formError("startTime", "Select time");
      } else {
        this.props.formError("startTime", "");
      }
    }
  }
  //Time List
  generateTimeData(startHour, endHour) {
    const timeData = [];
    for (let i = startHour; i <= endHour; i++) {
      if (i === 24) {
        timeData.push({ text: '12:00 am', label: '12:00 am', value: i })
        continue;
      }
      timeData.push({
        text: (i % 12 || 12) + ':00 ' + (i >= 12 ? 'pm' : 'am'),
        label: (i % 12 || 12) + ':00 ' + (i >= 12 ? 'pm' : 'am'),
        value: i
      });
    }
    // timeData.unshift({ text: 'Not set', value: null });
    return timeData;
  }

  readExcelData = (e, that, fileName) => {
    try {
      let data = e.target.result;
      let readedData = XLSX.read(data, { type: 'binary' });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];

      const priceData = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const columnsArray = priceData[0];
      const priceDataParsed = priceData.filter(row => row.some(cell => cell !== undefined && cell !== null && cell !== ''));

      let priceList = [];
      if (priceDataParsed.length > 0) {

        //Checking Market Price Column Availabilty
        let iMarketPricePosition = -1;
        let iMemberPricePosition = -1;
        let iPromotionPricePosition = -1;
        let iElitePricePosition = -1;
        for (let i = 0; i < columnsArray.length; i++) {
          if (priceDataParsed[0][i] === "market_price") {
            iMarketPricePosition = i;
          } else if (priceDataParsed[0][i] === "member_price") {
            iMemberPricePosition = i;
          } else if (priceDataParsed[0][i] === "promotion_price") {
            iPromotionPricePosition = i;
          } else if (priceDataParsed[0][i] === "elite_price") {
            iElitePricePosition = i;
          }
        }
        if (iMarketPricePosition < 0 || iPromotionPricePosition < 0) {
          this.props.formError("selectedFile", "Please make sure you include all price columns in the file");
          that.setState({ selectedFile: null });
        } else {
          let seen = new Set();
          let duplicates = [];
          let emptyLineDetected = false;
          priceList = priceDataParsed.slice(1).map(row => {
            let storeId = row[0];
            let skuid = row[1];
            if (storeId && skuid) {
              let identifier = `${storeId}-${skuid}`;
              if (seen.has(identifier)) {
                duplicates.push({ storeId, skuid }); // Capture duplicate info for review or handling
                return null; // Return null or handle differently if you still want to add the row
              } else {
                seen.add(identifier);
                return {
                  "storeId": storeId,
                  "skuid": skuid,
                  "marketprice": iMarketPricePosition > 0 ? row[iMarketPricePosition] : 0,
                  "memberprice": iMemberPricePosition > 0 ? row[iMemberPricePosition] : 0,
                  "eliteprice": iElitePricePosition > 0 ? row[iElitePricePosition] : 0,
                  "promotionprice": iPromotionPricePosition > 0 ? row[iPromotionPricePosition] : 0
                }
              }
            } else {
              emptyLineDetected = true;
            }
          });
          if (duplicates.length > 0) {
            let message = "";
            duplicates.forEach(function (data) {
              message += data.storeId + "-" + data.skuid + "\n";
            });
            alert("Duplicate records found with same storeId and sku, please check your data.");
            return;
          } else if (emptyLineDetected) {
            alert("Empty lines of data detected, please check your file and delete all empty lines.");
            return;
          } else {
            if (priceList.length > 0) {
              const startDate = new Date(that.props.startDate).toLocaleDateString('fr-CA');
              const scheduleData = {
                "branchId": that.props.branchId,
                "filename": fileName,
                "startdate": startDate,
                "starttime": that.props.startTime
              };
              const uploadData = { "Schedular": scheduleData, "ExcelData": priceList }
              console.log('Total data: ' + JSON.stringify(uploadData).length);
              that.props.uploadexcel(uploadData);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
    finally {
      this.props.hideLoading(); // Hide Loading
    }
  }

  render() {
    let p = this.props;
    const s = this.state;
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const maxDate = `${currentYear}-12-31`; ``
    const minDate = `${currentYear}-${currentMonth}-01`;
    const timeData = this.generateTimeData(1, 24);
    const defaultDate = new Date();
    defaultDate.setFullYear(defaultDate.getFullYear() - 20);
    defaultDate.setMonth(0);
    defaultDate.setDate(1);

    const styles = {
      uploadButton: {
        //marginRight
      },
      uploadInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '50%',
        opacity: 0
      }
    };

    const listOfSchedular = (this.props.bulkPriceSchedularList || []).map((item) => {
      return {

        Id: (<p>{item.id}</p>),
        FileName: (<p>{item.fileName}</p>),
        StartDate: (<p>{item.startDate}</p>),
        StartTime: (<p>{item.startTime}</p>),
        Status: item.status,
        Icons: (item.status == 'OPEN' ?
          <div>
            <CustomButton
              type="IconButton"
              className="glyphicon glyphicon-trash"
              icon={<DeleteOutlineOutlinedIcon />}
              onTouchTap={() => this.redirectToDelete(item.id)}
              mini={true}
            />
          </div>
          : item.status == 'CLOSED' ?
            (<div>CLOSED</div>) : ""
        )
      };
    });

    return (
      <Grid headerContent={bulkPriceCrumb}>
        <PageHeader title={LOOKUP.menu.manage.items.priceupdate.text} />
        <CardSimple className="p-1">
          <div className="row m-0">
            <div className="col-lg-9">
              <TextInput name={"selectedFileName"}
                label={LOOKUP.priceUpdate.name.label}
                hintText={LOOKUP.priceUpdate.name.hintText}
                helperText={"Note: Only one active Price Update can be opened, multiple price adjustments cannot be permitted."}
                disabled={true}
                fullWidth={true} />
            </div>
            <div className="col-lg-3 text-left mt-1">
              <ButtonFileUpload
                label="Upload"
                onChange={this.onFileChange}
                sx={{ ...styles.uploadButton }}
              />
            </div>
          </div>
          <div className="row m-0">
            <div className="col-lg-4">
              <DatePickerInput
                name={"startDate"}
                min={minDate}
                onChange={this.handleChange}
                max={maxDate}
                floatingLabelText={LOOKUP.priceUpdate.scheduleDate.label}
                required
              />
            </div>
            <div className="col-lg-4">
              <SelectInput
                name="startTime"
                floatingLabelText={LOOKUP.priceUpdate.startTime.label}
                options={timeData}
                onChange={this.handleTimeChange}
                required
              />
            </div>
          </div>
        </CardSimple>
        <PageBottomWithButtons>
          <CustomButton
            name="saveButton"
            className="btnNewBrandPOS mr-1"
            label={"RUN UPDATE NOW"}
            onTouchTap={() => this.doBulkPriceUpdate()}
            primary={true}
          />
          <CustomButton
            name="saveButton"
            className="pull-right btnNewBrandPOS"
            label={LOOKUP.weight.controls.saveButton}
            onTouchTap={() => this.saveExcelData()}
            primary={true}
          />
        </PageBottomWithButtons>
        <GenericTable
          multiSelectable={false}
          enableSelectAll={false}
          displaySelectAll={false}
          adjustForCheckbox={false}
          displayRowCheckbox={false}
          selectable={false}
          columns={LOOKUP.priceUpdate.tableColumns}
          rows={listOfSchedular}
          stripedRows={true}
        />
        <Pagination
          length={this.props.bulkPriceSchedularLength}
          itemsPerPage={s.itemsPerPage}
          activePage={s.activePage}
          onPageChange={this.changePage}
          maxButtons={4} />
        <DialogConfirm
          onConfirm={this.handleDeleteConfirm}
          onCancel={this.handleDeleteCancel}
          isOpen={this.state.isDialogOpen}
          title={LOOKUP.priceUpdate.deleteTitle}
          message={<h4 className="mt-7">{LOOKUP.priceUpdate.deleteMessage}</h4>} />
        <DialogException
          onConfirm={this.handleExceptionClose}
          isOpen={this.state.isExceptionDialogOpen}
          title={LOOKUP.priceUpdate.exceptionTitle}
          message={<p className="mt-9">{this.props.bulkPriceUpdateNotFoundSKUList}</p>} />
      </Grid>
    );
  }
}
function mapStatetoProps(state) {
  return {
    bulkPriceSchedularLength: state.entity.bulkPriceSchedularLength,
    bulkPriceSchedularList: state.entity.bulkPriceSchedularList,
    bulkPriceUpdate: state.entity.bulkPriceUpdate,
    deleteBulkPrice: state.entity.deleteBulkPriceList,
    updateBulkPrice: state.entity.updateBulkPriceList,
    branchId: state.common.branchId,
    startDate: state.form.startDate,
    startTime: state.form.startTimeText,
    selectedFileName: state.form.selectedFileName,
    schedularId: state.form.schedularId,
    validateExcelTimeSuccess: state.entity.validateExcelTimeSuccess,
    bulkPriceUpdateNotFoundSKUList: state.entity.bulkPriceUpdateNotFoundSKUList,
    updatePriceSchedularUpdateTimeSuccess: state.entity.updatePriceSchedularUpdateTimeSuccess,
    updateBulkPriceListSuccessTime: state.entity.updateBulkPriceListSuccessTime,
    updateBulkPriceListData: state.entity.updateBulkPriceListData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getBulkPriceUpdateSchedular: (branchId, page, itemsPerPage) => dispatch(getBulkPriceUpdateSchedular(branchId, page, itemsPerPage)),
    uploadexcel: (uploadData) => dispatch(uploadexcel(uploadData)),
    deleteBulkPriceList: (schedularId) => dispatch(deleteBulkPriceList(schedularId)),
    updateBulkPrice: () => dispatch(updateBulkPriceList()),
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    clearFormInput: (name) => dispatch(clearFormInput(name)),
    showError: (message) => dispatch(showError(message)),
    showLoading: () => dispatch(showLoadingSpinner()),
    hideLoading: () => dispatch(hideLoadingSpinner()),
    showDialog: (message) => dispatch({ type: types.DIALOG_ALERT_OPEN, message: message }),
    formInput: (value, name) => dispatch(formInput(value, name)),
    formError: (name, error) => dispatch(formError(name, error)),
    clearFormErrors: () => dispatch(clearFormErrors(null, null))
  };
}
export default connect(mapStatetoProps, mapDispatchToProps)(PriceUpdateList);
